<template>
  <div class="md-layout">
    <md-content class="task-menu" id="the-menu">
      <task-menu
        v-if="showMenu"
        :key="currentTask.id"
        :currentTask="currentTask"
        :isExtranet="isExtranet"
        :disabled-items="['executionEnd']"
        :showExecutionEnd="
          !!currentTask && currentTask.planExpected.status !== FINISHED
        "
        :show-set-real-quantities="!!currentTask"
        :executionEndDisabled="false"
        :show-close-authorization="
          !!currentTask && currentTask.planExpected.status === REVIEWED
        "
        @menuSelected="menuSelected"
        @menuClosed="closeMenu"
      >
        <template slot="menu-title">{{ currentTask.date }}</template>
      </task-menu>
    </md-content>

    <md-content id="task-tooltip">
      <md-tooltip :md-active.sync="tooltipActive" class="gantt-tooltip">
        <span v-html="tooltipText"></span>
      </md-tooltip>
    </md-content>

    <gantt-elastic
      :options="options"
      :tasks="expectedTasks"
      @tasks-changed="tasksUpdate"
      @dynamic-style-changed="styleUpdate"
    >
      <!--<gantt-header slot="header" :options="options"> </gantt-header> -->
      <!--@options-changed="optionsUpdate"-->
    </gantt-elastic>

    <md-button
      v-if="canAddWorkplanreal && !readOnly"
      @click="addTask"
      class="btn-floating md-rose md-just-icon md-round"
    >
      <md-icon>add</md-icon>
    </md-button>
  </div>
</template>

<script>
import GanttElastic from "gantt-elastic";
import GanttHeader from "gantt-elastic-header";
import TaskMenu from "./TaskMenu";
import moment from "moment";
import { throttle } from "lodash";
import locale from "./locale";
import { mapPermissions } from "../../../plugins/accountPermissions";
import {
  TASK_STATUS_ICONS,
  PLANNED,
  EXECUTION,
  FINISHED,
  REVIEWED,
  CLOSED,
  TASK_STATUS_LABELS,
} from "./utils";
import fromNowDate from "@/filters/fromNowDate";

// just helper to get current dates
function getDate(hours) {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();
  const timeStamp = new Date(
    currentYear,
    currentMonth,
    currentDay,
    0,
    0,
    0
  ).getTime();
  return new Date(timeStamp + hours * 60 * 60 * 1000).getTime();
}

function daysToMilliseconds(days) {
  return days * 24 * 60 * 60 * 1000;
}

const realActions = `
  <button class="md-button md-simple amber gt-button">
    <i class="md-icon">edit</i>
  </button>
  `;
const viewRealActions = `
  <button class="md-button md-simple gt-button">
    <i class="md-icon">visibility</i>
  </button>
  `;
const rejectActions = `
  <button class="md-button md-simple gt-button">
    <i class="md-icon">backspace</i>
  </button>
  `;

const pastRealActions = `
  <button class="md-button md-simple gt-button">
  <i class="md-icon">visibility</i>
  </button>
  `;

const makeRealLateAction = `
  <button class="md-button md-simple gt-button md-danger">
    <i class="md-icon">flag</i>
  </button>

`;

const makeRealAheadAction = `
  <button class="md-button md-simple gt-button md-info">
    <i class="md-icon">flag</i>
  </button>

`;

const makeRealAction = `
  <button class="md-button md-simple gt-button">
  <i class="md-icon">flag</i>
  </button>

`;

const PLANNED_FILL_COLOR = "#60CCDD";

const PLANNED_NO_REAL_FILL_COLOR = "#8995B1";
const PLANNED_LATE_REAL_FILL_COLOR = "#D66C4E";
const PLANNED_COMMING_REAL_FILL_COLOR = "#D66C4E";

const PAST_REAL_INVALID_COLOR = "#C75865";
const PAST_REAL_VALID_COLOR = "#61E070";

//const REAL_INVALID_COLOR = "#E5182F";
const REAL_INVALID_COLOR = "#ffaa00";
const REAL_VALID_COLOR = "#1EBC30";

const ENDED_COLOR = "#379793";

const ORIGINAL_PLAN_LABEL = "Planeación";
const PREVIOUS_EXECUTION_LABEL = "Día";
const FIRST_DAY_GROUP_LABEL = "Ejecutado - Día 1";
const FIRST_DAY_LABEL = "Ejecutado - Día 1";

const TASK_MENU_LABEL = "Registrar avances";
const TASK_MENU_NO_WORKING_DAY_LABEL =
  "Registrar avances (No se han subido avances hoy)";

const READ_TASK_INFO = "Ver evidencias";

function tooltipHandler(that, text = "") {
  return {
    show: throttle(() => {
      that.tooltipText = text;
      that.tooltipActive = true;
    }, 300),
    hide: throttle(() => {
      that.tooltipActive = false;
    }, 300),
  };
}

const ENDEND_CHECK = '<i class="md-icon task-icon">check_circle_outline</i> ';

const taskItemIcon = (status) =>
  `<i class="md-icon task-icon">${TASK_STATUS_ICONS[status] || ""}</i> `;

const FROM_NOW_DATE = (momentObj) => momentObj.locale("es").fromNow();

const SINISTERS_URL = "siniestros/carreteros";

export default {
  name: "Gantt",

  props: {
    title: {
      type: String,
      default: "Plan de Trabajo",
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    tooltipTimeout: {
      type: Number,
      default: 3000,
    },
    expected: Array,
    real: Array,
    default: () => [],
    sinistersURL: {
      type: String,
      default: SINISTERS_URL,
    },
    sort: {
      default: "dane",
      type: String,
    },
    isExtranet: {
      default: false,
      type: Boolean,
    },
    dontCollapseRealPlan: Boolean,
  },

  computed: {
    ...mapPermissions("WorkPlan", "workplanreal", ["change", "add"]),
    realHash() {
      const obj = {};
      const real = this.real || [];
      for (const realItem of real) {
        obj[realItem.planExpectedId] = realItem;
      }
      return obj;
    },
    expectedTasks() {
      const expected = this.expected || [];

      const tasksPairs = expected.map(this.makeTasks);
      let tasks = [];

      for (const taskPair of tasksPairs) {
        tasks = tasks.concat(taskPair);
      }
      tasks = [...tasks].sort(
        ({ start: startTimeA }, { start: startTimeB }) =>
          startTimeB - startTimeA
      );
      return tasks;
    },
  },

  components: {
    GanttElastic,
    GanttHeader,
    TaskMenu,
  },
  created() {
    // app.$on('gantt-elastic-ready', ganttElasticInstance => {
    // })
  },
  data() {
    return {
      showMenu: false,
      currentTask: null,
      tooltipActive: false,
      tooltipText: "",
      options: {
        taskMapping: {
          progress: "percent",
        },
        maxRows: 10,
        maxHeight: 600,
        times: {
          timeZoom: 18,
        },
        title: {
          label: this.title,
          html: false,
        },
        row: {
          height: 24,
        },
        calendar: {
          hour: {
            display: false,
          },
        },
        chart: {
          progress: {
            bar: false,
          },
          expander: {
            display: true,
          },
        },
        taskList: {
          expander: {
            straight: false,
          },
          columns: [
            {
              id: 3,
              label: "Siniestro",
              value: "taskLabel",
              width: 224,
              expander: true,
              html: true,
            },
            {
              id: 1,
              label: "Fecha",
              html: true,

              value: (task) => {
                const date = task.start;
                const longDate = moment(date).format("DD/MM HH:mm");
                const dateFormatted = longDate;
                if (task.parentId) {
                  return `<span class="text-gray">${dateFormatted}</span>`;
                }
                return dateFormatted;
              },
              width: 80,
            },
            {
              id: 6,
              // label: "Acciones",
              label: "",
              html: true,
              value: "actions",
              width: 36,
              events: {
                click({ event, data, column }) {
                  const el = document.getElementById("the-menu");

                  const { offsetWidth: elWidth, offsetHeight: elHeight } = el;
                  const { innerWidth: wWidth, innerHeight: wHeight } = window;
                  const { clientX, clientY } = event;

                  let top = clientY;
                  let left = clientX;

                  if (top + elHeight > wHeight) {
                    top = wHeight - elHeight;
                  }

                  if (left + elWidth > wWidth) {
                    left = wWidth - elWidth;
                  }

                  el.style.position = "fixed";
                  el.style.left = `${left}px`;
                  el.style.top = `${top}px`;
                  data.activateTaskMenu();
                },
                mouseover({ event, data, column }) {
                  const tooltip = data.tooltip;
                  if (tooltip) {
                    const { clientX, clientY } = event;
                    const el = document.getElementById("task-tooltip");
                    el.style.position = "fixed";
                    el.style.left = `${clientX}px`;
                    el.style.top = `${clientY}px`;
                    tooltip.show();
                  }
                },
                mouseout({ event, data, column }) {
                  const tooltip = data.tooltip;
                  if (tooltip) {
                    tooltip.hide();
                  }
                },
              },
            },
          ],
        },
        locale,
      },
      dynamicStyle: {},
      lastId: 16,
      taskCache: {},
      FINISHED,
      REVIEWED,
      CLOSED,
      EXECUTION,
      PLANNED,
      QUANTITIES_STATUSES: [FINISHED, REVIEWED, CLOSED],
      FINISHING_STATUSES: [FINISHED, REVIEWED],
    };
  },
  watch: {
    tooltipActive(value) {
      if (value) {
        setTimeout(function () {
          this.tooltipActive = false;
        }, this.tooltipTimeout);
      }
    },

    title(value) {
      this.options = {
        ...this.options,
        title: {
          label: value,
          html: false,
        },
      };
    },
  },

  methods: {
    menuSelected(eventName) {
      this.showMenu = false;
      this.$emit(eventName, this.currentTask);
    },
    makeRealTask(
      realPlan,
      { start, end, writable, hasPhotos, workingDay },
      taskInfo,
      validColor = PAST_REAL_VALID_COLOR,
      invalidColor = PAST_REAL_INVALID_COLOR
    ) {
      const dateKey = start.format("YYYY-MM-DD");

      const style = {
        base: {
          // fill: '#1EBC30', //green
          fill: hasPhotos ? validColor : invalidColor,
          stroke: "#80D719",
        },
      };

      const that = this;
      return {
        start,
        end,
        type: "task",
        style,
        activateTaskMenu() {
          that.showMenu = true;
          that.currentTask = {
            ...realPlan,
            date: dateKey,
            readOnly: !writable,
            workingDay,
          };
        },
        ...taskInfo,
        // tooltip: tooltipHandler(that, 'Mostrar menú')
      };
    },
    makePastRealTasks(
      realPlan,
      workingDays,
      {
        id,
        labelLink,
        label,
        affectedRequisitionNumber,
        today,
        pDays,
        dateFormatted,
        rStartDay,
        parentId,
      }
    ) {
      let prevTasks = [];
      const {
        planExpected: { status },
      } = realPlan;

      const yesterday = today.clone();
      yesterday.subtract(1, "days");

      const fDate = today.clone();
      fDate.subtract(pDays, "days");

      const efDate = fDate.clone();
      efDate.add(1, "days");

      const [firstWorkingDay, ...restWorkingDays] = workingDays;

      const that = this;
      let fId;

      if (firstWorkingDay) {
        fId = `${id}-real-${firstWorkingDay.startDateFormatted}`;

        const oStart = firstWorkingDay.startDate;
        const oEnd = firstWorkingDay.finishDate;

        const first = this.makeRealTask(
          realPlan,
          {
            start: oStart,
            end: oEnd,
            hasPhotos: firstWorkingDay.allSecurityPhorosUploaded,
            workingDay: firstWorkingDay,
          },
          {
            id: fId,
            pastExecution: true,
            // label: `${FIRST_DAY_LABEL} <strong>(${FROM_NOW_DATE(rStartDay)})</strong>`,
            taskLabel: `<span class="text-gray">${
              restWorkingDays.length > 0
                ? FIRST_DAY_GROUP_LABEL
                : FIRST_DAY_LABEL
            }</span>`,
            parentId,

            collapsed: true,
            affectedRequisitionNumber,
            percent: 100,
            type: "task",
            actions: pastRealActions,
            tooltip: tooltipHandler(that, READ_TASK_INFO),
          }
        );

        prevTasks.push(first);
      }
      let dayCount = 1;
      for (const workingDay of restWorkingDays) {
        dayCount += 1;
        const start = workingDay.startDate;
        const end = workingDay.finishDate;
        const dateKey = `${start.format("YYYY-MM-DDTH:M")}-${
          workingDay.id || 0
        }`;

        prevTasks.push(
          this.makeRealTask(
            realPlan,
            {
              start,
              end,
              hasPhotos: workingDay.allSecurityPhorosUploaded,
              workingDay,
            },
            {
              id: `${id}-real-${dateKey}`,
              pastExecution: true,
              // label: `${PREVIOUS_EXECUTION_LABEL} ${FROM_NOW_DATE(start)}`,
              taskLabel: `${PREVIOUS_EXECUTION_LABEL} ${dayCount}`,
              parentId: fId,
              affectedRequisitionNumber,
              percent: 0,
              type: "task",
              actions: pastRealActions,
              tooltip: tooltipHandler(that, READ_TASK_INFO),
            }
          )
        );
      }

      return prevTasks;
    },
    makeRealTasks(
      realPlan,
      {
        id,
        labelLink,
        label,
        affectedRequisitionNumber,
        planExpected,
        finishDate,
      }
    ) {
      const { readOnly } = this;
      const { status } = planExpected;
      const statusLabel = `${taskItemIcon(status)}${
        TASK_STATUS_LABELS[status]
      }`;

      const today = moment(new Date()).startOf("day");

      const eFinishDay = moment(finishDate, "YYYY-MM-DD");
      const rStartDay = moment(realPlan.startDate);
      const rFinishDay = realPlan.finishDate && moment(realPlan.finishDate);

      const pDays = moment.duration(today.diff(rStartDay)).asDays();

      const days = moment.duration(eFinishDay.diff(today)).asDays();

      const that = this;

      const tomorrow = today.clone();
      tomorrow.add(1, "days");

      const dateFormatted = today.format("YYYY-MM-DD");

      const style = {
        base: {
          // fill: '#1EBC30', //green
          fill: true ? REAL_VALID_COLOR : REAL_INVALID_COLOR,
          stroke: "#80D719",
        },
      };

      const todayTask = [];

      const workingDays = [...realPlan.workingDays];
      const firstIndex = workingDays.findIndex((wD) =>
        wD.startDate.isSame(today, "day")
      );
      const todayWorkingDay = firstIndex >= 0 && workingDays[firstIndex];
      const pastWorkingDays = workingDays.slice(0, firstIndex);
      if (!realPlan.finishDate) {
        const todayLabel = !realPlan.finishDate
          ? labelLink
          : `${ENDEND_CHECK} ${labelLink}`;

        let start, end, hasPhotos, workingDay, tooltip, dayInitiated;

        if (todayWorkingDay) {
          dayInitiated = true;
          start = todayWorkingDay.startDate;
          end = todayWorkingDay.finishDate;
          hasPhotos = todayWorkingDay.allSecurityPhorosUploaded;
          workingDay = todayWorkingDay;
          tooltip = TASK_MENU_LABEL;
        } else {
          start = today;
          end = today.clone().endOf("day");
          tooltip = TASK_MENU_NO_WORKING_DAY_LABEL;
        }
        const todayRealTask = this.makeRealTask(
          realPlan,
          {
            start: rStartDay,
            end,
            writable: !realPlan.finishDate,
            hasPhotos,
          },
          {
            collapsed: !this.dontCollapseRealPlan,
            id: `${id}-real`,
            taskLabel: todayLabel,
            status,
            statusLabel,
            pastExecution: false,
            affectedRequisitionNumber,
            percent: 0,
            actions: readOnly ? viewRealActions : realActions,
            activateTaskMenu() {
              that.showMenu = true;
              that.currentTask = {
                ...realPlan,
                dayInitiated,
                date: dateFormatted,
              };
            },
            tooltip: tooltipHandler(that, tooltip),
          },
          //  colors
          REAL_VALID_COLOR,
          REAL_INVALID_COLOR
        );

        todayTask.push(todayRealTask);

        if (pDays <= 0) {
          return todayTask;
        }
      } else if (realPlan.finishDate) {
        const endedLabel = `${ENDEND_CHECK} ${labelLink}`;
        const todayRealTask = this.makeRealTask(
          realPlan,
          {
            start: rStartDay,
            end: rFinishDay,
            writable: !false,
          },
          {
            id: `${id}-finished`,
            taskLabel: endedLabel,
            pastExecution: false,
            status,
            collapsed: true,
            percent: 100,
            actions: viewRealActions,
            activateTaskMenu() {
              that.showMenu = true;
              that.currentTask = {
                ...realPlan,
                readOnly: true,
              };
            },
            tooltip: tooltipHandler(that, READ_TASK_INFO),
          },
          ENDED_COLOR,
          ENDED_COLOR
        );

        todayTask.push(todayRealTask);
      }

      const prevTasks = this.makePastRealTasks(realPlan, pastWorkingDays, {
        parentId: todayTask.length ? todayTask[0].id : id,
        id,
        labelLink,
        affectedRequisitionNumber,
        today,
        pDays,
        dateFormatted,
        rStartDay,
      });

      return [...todayTask, ...prevTasks];
    },
    makeTasks(expectPlan) {
      const { sinistersURL } = this;
      const today = moment(new Date()).startOf("day");
      const startMoment = expectPlan.dateObjects.startDate;
      const start = startMoment.toString();
      const end = expectPlan.dateObjects.finishDate.endOf("day").toString();
      const status = expectPlan.status;
      const statusLabel = `<strong>${taskItemIcon(status)}${
        TASK_STATUS_LABELS[status]
      }</strong>`;

      const affectedRequisitionNumber = expectPlan.affected.requisitionNumber;

      const id = expectPlan.id;
      const sid = expectPlan.sinisterId;
      const rsid = expectPlan.roadSinisterId;
      const label = `R${affectedRequisitionNumber}`;
      const labelLink = `<a class="sinister-link" href="/${sinistersURL}/${rsid}" target="_blank">${label}</a><span class="plan-status plan-${status.toLowerCase()}">${statusLabel}</span><br><strong class="sinister-number">${
        expectPlan.sinisterNumber
      }</strong>`;

      const that = this;

      const realItem = this.realHash[id];

      let tasks = [];

      let real;

      if (realItem) {
        realItem.planExpected = expectPlan;

        real = this.makeRealTasks(realItem, {
          id,
          labelLink,
          taskLabel: label,
          affectedRequisitionNumber,
          planExpected: expectPlan,
          finishDate: expectPlan.finishDate,
        });
        tasks.push(...real);
      }

      const daysDiff = startMoment.startOf("day").diff(today, "days");
      const realStartsToday = !realItem && daysDiff === 0;

      const realIsLate = !realItem && daysDiff < 0;

      const realStartLater = !realItem && daysDiff > 0;

      let actions, fillColor;

      if (realStartsToday) {
        fillColor = PLANNED_NO_REAL_FILL_COLOR;
        actions = makeRealAction;
      } else if (realIsLate) {
        fillColor = PLANNED_LATE_REAL_FILL_COLOR;
        if (this.canChangeWorkplanreal) {
          actions = makeRealLateAction;
        }
      } else if (realStartLater) {
        fillColor = PLANNED_COMMING_REAL_FILL_COLOR;
        actions = makeRealAheadAction;
      } else {
        fillColor = PLANNED_FILL_COLOR;
      }

      let parentId;

      const firstReal = real ? real[0] : {};
      if (!firstReal.pastExecution) {
        parentId = firstReal.id;
      }

      let tooltip = "Iniciar reparación";

      if (realIsLate) {
        tooltip += " <strong>(tarde)</strong> ";
      } else if (realStartLater) {
        tooltip += " <strong> (antes) </strong> ";
      }

      const plannedClass = !real ? "" : "text-gray";
      let planned;

      planned = {
        id,
        // label: !real ? labelLink : `<strong>${ORIGINAL_PLAN_LABEL}</strong> ${label}`,
        taskLabel: !real
          ? labelLink
          : `<strong class="${plannedClass}">${ORIGINAL_PLAN_LABEL}</strong>`,
        status: !real ? status : "",
        statusLabel: !real ? statusLabel : "",
        start: startMoment,
        startMoment,
        end: expectPlan.finishDate,
        style: {
          base: {
            fill: fillColor,
            stroke: "#80D719",
          },
        },
        parentId,
        affectedRequisitionNumber,
        type: "task",
        // status,
        actions: (!this.readOnly && actions) || "",
        activateTaskMenu() {
          that.$emit("makeReal", expectPlan, daysDiff);
        },
        tooltip: tooltipHandler(that, tooltip),
      };

      tasks.push(planned);

      return tasks;
    },
    addTask() {
      this.$emit("addTask");
    },
    tasksUpdate(tasks) {
      this.tasks = tasks;
    },
    optionsUpdate(options) {
      this.options = options;
    },
    styleUpdate(style) {
      this.dynamicStyle = style;
    },
    closeMenu() {
      this.currentTask = null;
      this.showMenu = false;
    },
  },
};
</script>

<style lang="scss">
@import "~vue-material/dist/theme/engine"; // Import the theme engine

.btn-floating {
  width: 40px !important;
  height: 40px !important;
  position: relative;
  top: -20px;
  left: -5px;
  z-index: 2;
}

ul.task-menu {
  position: absolute;
}

.task-menu#the-menu {
  z-index: 1;
}

.sinister-link {
  font-weight: 700;
  color: md-get-palette-color(red, 900) !important;
}

.gantt-tooltip {
  font-size: 16px !important;
}
.vue-slider-dot {
  z-index: 1 !important;
}

.gt-button {
  padding: 0 0 0 0 !important;
  margin: 0 0 0 0 !important;
  min-width: 24px !important;
  width: 24px !important;
}

.md-button.gt-button i.md-icon {
  color: #999 !important;
}

.sinister-number {
  font-size: 10px;
}

.plan-status i.md-icon {
  font-size: 16px !important;
  height: 16px;
  width: 16px;
  min-width: 16px;
}

.plan-status {
  height: 12px !important;
  font-size: 12px;
  text-transform: uppercase;
  color: md-get-palette-color(cyan, 700);
  float: right;
}

.plan-status.plan-closed {
  color: md-get-palette-color(green, 400);
}

.md-icon.task-icon {
  font-size: 18px !important;
  height: 18px;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/pages/WorkPlan/WeeklyExecution/Gantt.vue